import { render, staticRenderFns } from "./liveWallet.vue?vue&type=template&id=6c3c816a&scoped=true&"
import script from "./liveWallet.vue?vue&type=script&lang=js&"
export * from "./liveWallet.vue?vue&type=script&lang=js&"
import style0 from "./liveWallet.vue?vue&type=style&index=0&id=6c3c816a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3c816a",
  null
  
)

export default component.exports